import { onBeforeUnmount, shallowRef, watch, type Ref, type WatchSource } from 'vue'
import { debounce } from '@shared/utils'

/** How long a quantity / price must settle before it is re-priced by the server. */
export const QUOTE_DEBOUNCE_MS = 350

// Trailing-edge copy of `source` for a query key — a slider drag or typing
// re-prices once the value settles, not on every step. The first value is
// taken at once so a drawer opens with a quote straight away.
export function useDebouncedValue<T>(source: WatchSource<T>, delay = QUOTE_DEBOUNCE_MS): Ref<T> {
  const read = typeof source === 'function' ? source : () => source.value
  const settled = shallowRef<T>(read())
  let isActive = true
  const commit = debounce((value: T) => {
    if (isActive) settled.value = value
  }, delay)
  watch(source, (value) => commit(value))
  onBeforeUnmount(() => {
    isActive = false
  })
  return settled
}
